import "./_spinner.scss";

import classNames from "classnames";

interface SpinnerProps {
  customClassName?: string;
}

function Spinner({customClassName}: SpinnerProps) {
  return (
    <div className={classNames("spinner-container", customClassName)}>
      <div className={"spinner"}>
        <div className={"spinner__ring"} />
        <div className={"spinner__ring"} />
      </div>
    </div>
  );
}

export default Spinner;
